import type {RootState} from '@/state/store';

export const selectInsightsContext = (state: RootState) => state.insights.context;
export const selectIsRetail = (state: RootState) => state.insights.context?.isRetail ?? false;
export const selectIsRangeModeEnabled = (state: RootState) => state.insights.context?.isRangeModeEnabled ?? false;
